import { defineStore } from 'pinia'
import axios from 'axios'
import { ref, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export const useClientStore = defineStore('ClientStore', {
    state: () => {
        return {
            menu: ref([
                    {
                        "title": "Home",
                        "name": "client-dashboard",
                        "icon": "home"
                    },
                    {
                        "title": "Client Detail",
                        "name": "client-detail",
                        "icon": "package"
                    },
                    {
                        "title": "Credit Analysis",
                        "name": "get-credit-analysis",
                        "icon": "bar-chart"
                    },
                    {
                        "title": "Credit Report",
                        "name": "creditreport",
                        "icon": "layers"
                    },
                    {
                        "title": "All Messages",
                        "name": "client-message",
                        "icon": "message-circle"
                    },
                    {
                        "title": "Plans",
                        "name": "client-plans",
                        "icon": "dollar-sign"
                    },
                    {
                        "title": "logout",
                        "name": "client-logout",
                        "icon": "power",
                    }
                ]),
        }
    },
    actions: {

    },
    getters: {
    },
})
